export const ReviewsData = [
  {
    id: "1",
    image: "assets/img/products/stock-img-01.png",
    Product_Name: "Lenovo IdeaPad 3",
    Author: "James Kirwin",
    User_image:"assets/img/users/user-30.jpg",
    Review: "Sleek design and excellent battery life",
    Ratings: "",
    Date: "24 Dec 2024",
    Status: "Published",
  },
  {
    id: "2",
    image: "assets/img/products/stock-img-06.png",
    Product_Name: "Beats Pro",
    Author: "Francis Chang",
    User_image:"assets/img/users/user-13.jpg",
    Review: "Crystal-clear sound and deep bass",
    Ratings: "",
    Date: "10 Dec 2024",
    Status: "Published",
  },
  {
    id: "3",
    image: "assets/img/products/stock-img-02.png",
    Product_Name: "Nike Jordan",
    Author: "Antonio Engle",
    User_image:"assets/img/users/user-11.jpg",
    Review: "Stylish, durable, and incredibly comfortable",
    Ratings: "",
    Date: "27 Nov 2024",
    Status: "Published",
  },
  {
    id: "4",
    image: "assets/img/products/stock-img-03.png",
    Product_Name: "Apple Series 5 Watch",
    Author: "Leo Kelly",
    User_image:"assets/img/users/user-32.jpg",
    Review: "Ultimate fitness and lifestyle companion!",
    Ratings: "",
    Date: "18 Nov 2024",
    Status: "Published",
  },
  {
    id: "5",
    image: "assets/img/products/stock-img-04.png",
    Product_Name: "Amazon Echo Dot",
    Author: "Annette Walker",
    User_image:"assets/img/users/user-02.jpg",
    Review: "Perfect voice-controlled home assistant!",
    Ratings: "",
    Date: "06 Nov 2024",
    Status: "Published",
  },
  {
    id: "6",
    image: "assets/img/products/stock-img-05.png",
    Product_Name: "Sanford Chair Sofa",
    Author: "John Weaver",
    User_image:"assets/img/users/user-05.jpg",
    Review: "Elegant design and superb comfort",
    Ratings: "",
    Date: "25 Oct 2024",
    Status: "Published",
  },
  {
    id: "7",
    image: "assets/img/products/expire-product-01.png",
    Product_Name: "Red Premium Satchel",
    Author: "Gary Hennessy",
    User_image:"assets/img/users/user-08.jpg",
    Review: "perfect for work, travel, and everyday use",
    Ratings: "",
    Date: "14 Oct 2024",
    Status: "Published",
  },
  {
    id: "8",
    image: "assets/img/products/expire-product-02.png",
    Product_Name: "Iphone 14 Pro",
    Author: "Eleanor Panek",
    User_image:"assets/img/users/user-04.jpg",
    Review: "Powerful performance and stunning display",
    Ratings: "",
    Date: "03 Oct 2024",
    Status: "Published",
  },
  {
    id: "9",
    image: "assets/img/products/expire-product-03.png",
    Product_Name: "Gaming Chair",
    Author: "William Levy",
    User_image:"assets/img/users/user-09.jpg",
    Review: "Ergonomic and incredibly comfortable",
    Ratings: "",
    Date: "20 Sep 2024",
    Status: "Published",
  },
  {
    id: "10",
    image: "assets/img/products/expire-product-04.png",
    Product_Name: "Borealis Backpack",
    Author: "Charlotte Klotz",
    User_image:"assets/img/users/user-10.jpg",
    Review: "Perfect for work, school and travel!",
    Ratings: "",
    Date: "10 Sep 2024",
    Status: "Published",
  },
  {
    id: "11",
    image: "assets/img/products/expire-product-04.png",
    Product_Name: "Borealis Backpack",
    Author: "Charlotte Klotz",
    User_image:"assets/img/users/user-10.jpg",
    Review: "perfect for work, travel, and everyday use",
    Ratings: "",
    Date: "03 Oct 2024",
    Status: "Published",
  },
];
